<template>
  <div id="careers-app">
    <career-filters></career-filters>
    <careers-list></careers-list>
  </div>
</template>

<script>

import CareersList from './components/CareersList.vue'
import CareerFilters from './components/CareerFilters.vue'

export default {
  components: {CareersList, CareerFilters},
  name: 'careers-app'
}
</script>